import { _ as t } from "./index742.mjs";
import { f as e } from "./index743.mjs";
var a = t, o = e, r = Date, n = o(r.prototype.getTime);
a({ target: "Date", stat: !0 }, {
  now: function() {
    return n(new r());
  }
});
